module.exports = __webpack_public_path__ + "static/media/overstock.ac5d554c.png";